// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TabbedButton_buttonContainer__y4hW9","button":"TabbedButton_button__69HIM","active":"TabbedButton_active__7wKag"};